import Desc from './desc.vue'

Desc.install = (app) => {
  app.component(Desc.name, Desc)
}

export default Desc
